<template>
  <div>
    <div class="sheet">
      <div>
      <!-- 免許種類 -->
        <!--
        <div v-for="(pos,index) in ob.n1" :key="'n1' + index" class = "waku_x" :style="{left:this.$pa.n1[index].x+'mm',top:this.$pa.n1[index].y+'mm'}" >
          <div v-if="ob.n1.indexOf(index) == index" class="moji_x">x</div>
          <div v-else class="moji_x"></div>
        </div>
        -->
        <div v-for="(pos,index) in this.$pa.n1" :key="'n1' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div v-for="(i,index2) in ob.n1" :key="'n1-c' + index2">
            <div v-if="i == index" class="moji_x">x</div>
            <div v-else class="moji_x"></div>
          </div>
        </div>
      <!-- 免許証番号 -->
        <div v-for="(pos,index) in this.$pa.n2" :key="'n2' + index"  >
          <div v-for="(moji,index2) in ob.n2[index]" :key="'ob_n2' + index + index2" class = "waku_n1" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_n1">{{moji}}</div>
          </div>
        </div>
      <!-- 小文字区分 -->
      <!--
        <div v-for="(pos,index) in $pa.n3_1" :key="'n3_1' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div class="moji_x">x</div>
        </div>
      -->  
        <div v-for="(pos,index) in this.$pa.n3_1" :key="'n3_1' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div v-for="(i,index2) in ob.n3_1" :key="'n3_1-c' + index2">
            <div v-if="i == index" class="moji_x">x</div>
            <div v-else class="moji_x"></div>
          </div>
        </div>
      <!-- カタカナ -->
        <div v-for="(pos,index) in this.$pa.n3_2" :key="'n3_2' + index"  >
          <div v-for="(moji,index2) in ob.n3_2[index]" :key="'ob_n3_2' + index + index2" class = "waku_kana" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_kana">{{moji}}</div>
          </div>
        </div>
      <!-- 漢字名前 -->
        <div v-for="(pos,index) in this.$pa.n3_3" :key="'n3_3' + index"  >
          <div v-for="(moji,index2) in ob.n3_3[index]" :key="'ob_n3_3' + index + index2" class = "waku_kanji" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_kanji">{{moji}}</div>
          </div>
        </div>
      <!-- 名前変更 -->
        <div v-for="(pos,index) in this.$pa.n3_4" :key="'n3_4' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
          <div v-if="ob.n3_4" class="moji_x">x</div>
          <div v-else class="moji_x"></div>
        </div>
      <!-- 郵便番号 -->
        <div v-for="(pos,index) in this.$pa.n4_1" :key="'n4_1' + index"  >
          <div v-for="(moji,index2) in ob.n4_1[index]" :key="'ob_n4_1' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 電話番号 -->
        <div v-for="(pos,index) in this.$pa.n4_2" :key="'n4_2' + index"  >
          <div v-for="(moji,index2) in ob.n4_2[index]" :key="'ob_n4_2' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 都道府県 漢字 1 -->
        <div v-for="(pos,index) in this.$pa.n4_3" :key="'n4_3' + index"  >
          <div v-for="(moji,index2) in ob.n4_3[index]" :key="'ob_n4_3' + index + index2" class = "waku_kanji" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_kanji">{{moji}}</div>
          </div>
        </div>
      <!-- 都道府県丸1 -->
        <div v-for="(pos,index) in $pa.n4_4" :key="'n4_4' + index" class = "waku_o" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div class="moji_o"></div>
        </div>
      <!-- 住所 -->
        <div v-for="(pos,index) in this.$pa.n4_5" :key="'n4_5' + index"  >
          <div v-for="(moji,index2) in ob.n4_5[index]" :key="'ob_n4_5' + index + index2" class = "waku_kanji" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_kanji">{{moji}}</div>
          </div>
        </div>
      <!-- 住所変更 -->
        <div v-for="(pos,index) in this.$pa.n4_6" :key="'n4_6' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
          <div v-if="ob.n4_6" class="moji_x">x</div>
          <div v-else class="moji_x"></div>
        </div>
      <!-- 年号 -->
        <div v-for="(pos,index) in this.$pa.n5_1" :key="'n5_1' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div v-for="(i,index2) in ob.n5_1" :key="'n5_1-c' + index2">
            <div v-if="i == index" class="moji_x">x</div>
            <div v-else class="moji_x"></div>
          </div>
        </div>
      <!-- 西暦 -->
        <div v-for="(pos,index) in this.$pa.n5_2" :key="'n5_2' + index"  >
          <div v-for="(moji,index2) in ob.n5_2[index]" :key="'ob_n5_2' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 出生年月日 -->
        <div v-for="(pos,index) in this.$pa.n5_3" :key="'n5_3' + index"  >
          <div v-for="(moji,index2) in ob.n5_3[index]" :key="'ob_n5_3' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 男女 -->
        <div v-for="(pos,index) in $pa.n6" :key="'n6' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div v-for="(i,index2) in ob.n6" :key="'n6-c' + index2">
            <div v-if="i == index" class="moji_x">x</div>
            <div v-else class="moji_x"></div>
          </div>
        </div>
      <!-- 都道府県 漢字 2 -->
        <div v-for="(pos,index) in this.$pa.n7_1" :key="'n7_1' + index"  >
          <div v-for="(moji,index2) in ob.n7_1[index]" :key="'ob_n7_1' + index + index2" class = "waku_kanji" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_kanji">{{moji}}</div>
          </div>
        </div>
      <!-- 都道府県丸2 -->
        <div v-for="(pos,index) in $pa.n7_2" :key="'n7_2' + index" class = "waku_o" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div class="moji_o"></div>
        </div>
      <!-- 都道府県変更 -->
        <div v-for="(pos,index) in this.$pa.n7_3" :key="'n7_3' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
          <div v-if="ob.n7_3" class="moji_x">x</div>
          <div v-else class="moji_x"></div>
        </div>
      <!-- 国名 -->
        <div v-for="(pos,index) in this.$pa.n8_1" :key="'n8_1' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div v-for="(i,index2) in ob.n8_1" :key="'n8_1-c' + index2">
            <div v-if="i == index" class="moji_x">x</div>
            <div v-else class="moji_x"></div>
          </div>
        </div>
      <!-- 国コード -->
        <div v-for="(pos,index) in this.$pa.n8_2" :key="'n8_2' + index"  >
          <div v-for="(moji,index2) in ob.n8_2[index]" :key="'ob_n8_2' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 国籍変更 -->
        <div v-for="(pos,index) in this.$pa.n8_3" :key="'n8_3' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
          <div v-if="ob.n8_3" class="moji_x">x</div>
          <div v-else class="moji_x"></div>
        </div>
      <!-- 申請月日 -->
        <div v-for="(pos,index) in this.$pa.n9" :key="'n9' + index"  >
          <div v-for="(moji,index2) in ob.n9[index]" :key="'ob_n9' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 特例申請 -->
        <div v-for="(pos,index) in this.$pa.n10" :key="'n10' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div v-for="(i,index2) in ob.n10" :key="'n10-c' + index2">
            <div v-if="i == index" class="moji_x">x</div>
            <div v-else class="moji_x"></div>
          </div>
        </div>
      <!-- 更新要件 -->
        <div v-for="(pos,index) in $pa.n11" :key="'n11' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div v-for="(i,index2) in ob.n11" :key="'n11-c' + index2">
            <div v-if="i == index" class="moji_x">x</div>
            <div v-else class="moji_x"></div>
          </div>
        </div>
      <!-- 講習機関 -->
        <div v-for="(pos,index) in this.$pa.n12" :key="'n12' + index"  >
          <div v-for="(moji,index2) in ob.n12[index]" :key="'ob_n12' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 講習実施都道府県 -->
        <div v-for="(pos,index) in this.$pa.n13" :key="'n13' + index"  >
          <div v-for="(moji,index2) in ob.n13[index]" :key="'ob_n13' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 講習実施年月日 -->
        <div v-for="(pos,index) in this.$pa.n14" :key="'n14' + index"  >
          <div v-for="(moji,index2) in ob.n14[index]" :key="'ob_n14' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 更新地方運輸局等 -->
        <div v-for="(pos,index) in this.$pa.n15_1" :key="'n15_1' + index"  >
          <div v-for="(moji,index2) in ob.n15_1[index]" :key="'ob_n15_1' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
        <div v-for="(pos,index) in this.$pa.n15_2" :key="'n15_2' + index"  >
          <div v-for="(moji,index2) in ob.n15_2[index]" :key="'ob_n15_2' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 免許証更新年月日 -->
        <div v-for="(pos,index) in this.$pa.n16" :key="'n16' + index"  >
          <div v-for="(moji,index2) in ob.n16[index]" :key="'ob_n16' + index + index2" class = "waku_9" :style="{left:pos.x+'mm',top:pos.y+'mm'}">
            <div class="moji_9">{{moji}}</div>
          </div>
        </div>
      <!-- 免許証返納の有無 -->
        <div v-for="(pos,index) in $pa.n17" :key="'n17' + index" class = "waku_x" :style="{left:pos.x+'mm',top:pos.y+'mm'}" >
          <div v-for="(i,index2) in ob.n17" :key="'n17-c' + index2">
            <div v-if="i == index" class="moji_x">x</div>
            <div v-else class="moji_x"></div>
          </div>
        </div>

      </div>
    </div>
  </div>
  
</template>

<script>


export default {
  data(){
    return{
    }
  },
  props: ['ob'],
  computed:{
    b_n3_3:function(){
      var bunkatu = this.ob.n3_3.split('');
      return bunkatu
    },
  }  

};
</script>

<style>
.waku_o{
  position: absolute;
  width: 6mm;
  height: 6mm;
  border: solid 0.3mm;
}
.moji_o{
  font-size: 1.3em;
  margin-top:-1.5mm;
  text-align:center;
}

.waku_9{
  position: absolute;
  width: 5mm;
  height: 7mm;
  border: solid 0.3mm;
}
.moji_9{
  font-family: OCRB;
  font-size: 1.3em;
  margin-top:0mm;
  text-align:center;
}
.waku_x{
  position: absolute;
  width: 4mm;
  height: 4mm;
  border: solid 0.3mm;
}
.moji_x{
  margin-top:-1.5mm;
  text-align:center;
}
.waku_n1{
  position: absolute;
  width: 5mm;
  height: 7mm;
  border: solid 0.3mm;
}
.moji_n1{
  font-family: OCRB;
  font-size: 1.3em;
  margin-top:0mm;
  text-align:center;
}
.waku_kana{
  position: absolute;
  width: 7mm;
  height: 7mm;
  border: solid 0.3mm;
}
.moji_kana{
  margin-top:-0.5mm;
  font-size: 1.2em;
  text-align:center;
}
.waku_kanji{
  position: absolute;
  width: 12mm;
  height: 12mm;
  border: solid 0.3mm;
}
.moji_kanji{
  margin-top:1.4mm;
  font-size:18pt;
  text-align:center;
}
.preview {
    margin: 0;
    /* overflow: hidden; */
    position: relative;
    /* -webkit-box-sizing: border-box; */
    /* box-sizing: border-box; */
    /* page-break-after: always; */
    background-image: url(../assets/座標_更新.png);
    background-size: cover;
    width: 210mm;
    height: 297mm;
}

.sheet{
  font-family: -apple-system, "Segoe UI", "Helvetica Neue", "Hiragino Kaku Gothic ProN", メイリオ, meiryo, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/Print.vue